import * as React from "react";
import { PageTitle, PageTitleProps } from "../PageTitle";
import { useHistory } from "react-router-dom";
import { AdminSideBar } from "@/components/SideBarAdmin";
import { SideBar } from "../SideBar";
import { Loader } from "semantic-ui-react";
import { cn } from "@/lib/utils";
import { SideBarMobileTrigger } from "@/components/SideBarBase";
import { useSocialCoachSession } from "@/utils";

interface PageWrapperProps extends Omit<PageTitleProps, "title"> {
  loading?: boolean;
  className?: string;
  title?: string;
  fitViewport?: boolean;
}

const PageWrapperFC: React.FC<React.PropsWithChildren<PageWrapperProps>> = ({
  children,
  loading = false,
  className = undefined,
  title,
  primaryAction,
  secondaryAction,
  actions,
  hideSeparator = false,
  breadcrumbs = [],
  fitViewport = false,
}) => {
  const history = useHistory();
  const { isAdmin } = useSocialCoachSession();

  return (
    <div className={cn("bg-white flex w-full", fitViewport ? "h-dvh max-h-dvh overflow-hidden" : "min-h-dvh")}>
      {isAdmin ? <AdminSideBar history={history} /> : <SideBar history={history} />}

      <div className={cn("flex flex-col grow min-w-0", fitViewport ? "h-dvh max-h-dvh overflow-hidden" : "min-h-dvh")}>
        <SideBarMobileTrigger />

        {loading ? (
          <div className="grow flex items-center justify-center">
            <Loader active size="large" />
          </div>
        ) : (
          <div
            className={cn(
              "flex flex-col grow min-w-0 gap-3",
              fitViewport ? "overflow-hidden" : "m-4 md:m-12.5",
              className
            )}
          >
            {title && (
              <PageTitle
                title={title}
                primaryAction={primaryAction}
                secondaryAction={secondaryAction}
                actions={actions}
                hideSeparator={hideSeparator}
                breadcrumbs={breadcrumbs}
              />
            )}
            {children}
          </div>
        )}
      </div>
    </div>
  );
};

export const PageWrapper = PageWrapperFC;
